var _circle, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstantBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8994 13.3121L8.68709 13.7066C8.62447 13.7144 8.58064 13.6324 8.60882 13.5621L11.4423 6.82861C11.4548 6.79736 11.483 6.77783 11.5112 6.77783H15.0084C15.0741 6.77783 15.1117 6.87157 15.071 6.93797L12.5444 10.8046C12.5005 10.871 12.5444 10.9726 12.6132 10.9648L15.7128 10.582C15.7849 10.5742 15.8287 10.6797 15.7786 10.7461L10.0209 19.1903C9.95824 19.2723 9.85492 19.1825 9.89249 19.0809L11.9777 13.4488C12.0027 13.3824 11.9589 13.3043 11.8994 13.3121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantBooking);
export default __webpack_public_path__ + "static/media/instant-booking.6093011e.svg";
export { ForwardRef as ReactComponent };